import React from "react";
import { Link } from "gatsby";
import Logo from "../svg/logo.svg";

const Footer = () => {
  return (
    <div>
      <footer className="footer">
        <div className="footer--menu">
          <Link to="/datenschutz">Datenschutz</Link>
          <Link to="/impressum">Impressum</Link>
        </div>
        <div className="footer--credits">
          <Link to="/">
            <Logo />
          </Link>{" "}
          © {new Date().getFullYear()} | Made with ❤️ by{" "}
          <a href="https://www.runemoller.com" target="_blank">
            RM
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
